import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Interactions {
    constructor() {
        this.recipeTitle = '';
        this.rowFlag = false;
        this.colFlag = false;
        this.mutationFlag = false;
        this.x = 0;
        this.y = 0;
        this.onHero = false;
        this.mousemove = {
            x: 0,
            y: 0
        };
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.appearOnScreen();
        this.sideAppearFilters();
        this.fadeinRegister();
        this.updateCoordinates();
        if ($('.js-container-mousemove').length > 0) {
            if ($('.js-mousemove svg').length > 0) {
                let anim = $('.js-mousemove svg').get(0).animate([{ transform: 'scale(1.1,1.1)' }, { transform: 'scale(1.0,1.0)' }], { direction: 'alternate', iterations: 'Infinity', fill: 'both', duration: 1000 });
                anim.pause();
                this.anim = anim;
            }

            $('.js-container-mousemove').on('mouseleave', (e) => {
                this.onHero = false;
                if (typeof this.anim !== 'undefined') {
                    this.anim.pause();
                }
            });
            $('.js-container-mousemove').on('mouseenter', (e) => {
                this.onHero = true;
                if (typeof this.anim !== 'undefined') {
                    this.anim.play();
                }
            });
        }
    }

    appearOnScreen() {
        $(document).ready(() => {
            const $rowItems = $('.js-appear-animation-row');
            const $colItems = $('.js-appear-animation-col');

            let rowItemsTop = 0;
            let rowItemsBottom = 0;
            if ($rowItems.length > 0) {
                rowItemsTop = $rowItems.offset().top;
                rowItemsBottom = rowItemsTop + $rowItems.outerHeight();
            }

            let colItemsTop = 0;
            let colItemsBottom = 0;
            if ($colItems.length > 0) {
                 colItemsTop = $colItems.offset().top;
                 colItemsBottom = colItemsTop + $colItems.outerHeight();
            }

            $rowItems.children().each((_, element) => {
                $(element).addClass('opacity-0');
            });

            $(window).on('scroll resize', () => {
                const viewportTop = $(window).scrollTop();
                const viewportBottom = viewportTop + $(window).height();

                if ($rowItems.length > 0 && (rowItemsBottom > viewportTop && rowItemsTop < viewportBottom) && !this.rowFlag) {
                    this.rowFlag = true;
                    $rowItems.children().each((index, element) => {
                        const $item = $(element);
                        setTimeout(() => {
                            $item.addClass('fade-in');
                        }, index * 200); // Delay by 0.2 seconds per list item
                    });
                }

                if ($colItems.length > 0 && (colItemsBottom > viewportTop && colItemsTop < viewportBottom) && !this.colFlag) {
                    this.colFlag = true;
                    $colItems.children().each((index, element) => {
                        const $item = $(element);
                        setTimeout(() => {
                            $item.addClass('col-fade-in');
                        }, index * 200); // Delay by 0.2 seconds per list item
                    });
                }
            });

            // Trigger the scroll event to check if elements are already visible on load
            $(window).trigger('scroll');
        });
    }

    fadeinRegister() {
        if (!window.Launchpad.pageBuilderEditMode) {
            const elements = $('.js-entry');
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.showCallback(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            });
            elements.each((i, e) => {
                observer.observe(e);
            });
        }
    }

    updateCoordinates(e) {
        this.updateCoordinates = this.updateCoordinates.bind(this);
        if ($('.js-container-mousemove').length > 0) {
            window.addEventListener('mousemove', (e) => {
                const rect = $('.js-container-mousemove').get(0).getBoundingClientRect();
                const mouseX = e.clientX; // Mouse X relative to the section
                const mouseY = e.clientY - rect.top;
                this.mousemove = {
                    x: mouseX,
                    y: mouseY
                };
            });
            if ($('.js-container-mousemove').length > 0) {
                this.animate();
            }
        }
    }

    showCallback(ele) {
        const delay = $(ele).data('delay');
        if (typeof delay === 'undefined') {
            $(ele).addClass('shows');
            $(ele).removeClass('.js-entry');
            $(ele).removeClass('.no-visible');
        } else {
            setTimeout(() => {
                $(ele).addClass('shows');
                $(ele).removeClass('.js-entry');
                $(ele).removeClass('.no-visible');
                }, delay * 1000);
        }
    }

    animate() {
        if ($('.js-container-mousemove').length > 0) {
            const rect = $('.js-container-mousemove').get(0).getBoundingClientRect();
            //const mouseX = e.clientX - rect.left; // Mouse X relative to the section
            //const mouseY = e.clientY - rect.top;
            const follower = $('.js-mousemove').get(0).getBoundingClientRect();
            const followerX = follower.left + follower.width / 2;
            const followerY = follower.top + follower.height / 2;

            if (!this.onHero) {
                $('.js-mousemove').get(0).style.transform = `translate(${(rect.width / 2)}px, ${(rect.height / 2 - follower.height / 2)}px)`;
                requestAnimationFrame(this.animate.bind(this));
                return;
            }


            if (this === 'undefined') return;
            const deltaX = (this.mousemove.x); // Adjust the multiplier for speed
            const deltaY = (this.mousemove.y);

            $('.js-mousemove').get(0).style.transform = `translate(${(deltaX - follower.width / 2)}px, ${(deltaY - follower.height / 2)}px)`;
            //console.log(`translate(${deltaX}px, ${deltaY}px)`);
            //console.log(`(${this.mousemove.x}, ${this.mousemove.y})`);
            //console.log(`(${followerX}, ${followerX})`);

            $('.js-container-mousemove').get(0).style.setProperty('--y', `${deltaY}`);
            $('.js-container-mousemove').get(0).style.setProperty('--x', `${deltaX}`);
            requestAnimationFrame(this.animate.bind(this));
        }
    }

    sideAppearFilters() {
        $(document).ready(() => {
            // Select the target anchor elements to observe
            const $anchor = $('.card-content-wrapper, .ftl-animate');

            // Create a MutationObserver to watch for changes in the 'href' attribute
            const observer = new MutationObserver((mutations) => {
                let mutationFlag = false;
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'href' && mutationFlag === false) {
                        $anchor.each((_, anchor) => {
                            const $anchorItem = $(anchor);
                            $anchorItem.removeClass('opacity-0');
                            if (window.innerWidth > 992) $anchorItem.removeClass('fade-in-LtF');
                            mutationFlag = false;
                        });
                        mutationFlag = true;
                    }
                });
            });

            // Observe each anchor element for attribute changes
            $anchor.each((_, anchor) => {
                observer.observe(anchor, {
                    attributes: true, // Watch for attribute changes
                    attributeFilter: ['href'] // Only watch 'href' attribute
                });
            });
        });
    }
}

export default Interactions;

$(() => {
    const interactions = new Interactions();
    interactions.init();
});
